import React, { useEffect, useState } from "react";
import "./demo.css";
import Verify from "../lottie/Animation - 1704887243322.json";
import Lottie from 'react-lottie';

const districtWhatsApp = [
  {
      "d_id": 1,
      "d_name_ka": "ಬಾಗಲಕೋಟೆ",
      "d_name_en": "Bagalkot",
      "whasAppLink": "https://chat.whatsapp.com/Fxa1ajoH7sK3JWfGv3cHok"
  },
  {
      "d_id": 2,
      "d_name_ka": "ಬೆಂಗಳೂರು ಗ್ರಾಮಾಂತರ",
      "d_name_en": "Bengaluru Rural",
      "whasAppLink": "https://chat.whatsapp.com/DUQQk23OgmOL95klSEzX25"
  },
  {
      "d_id": 3,
      "d_name_ka": "ಬೆಂಗಳೂರು ನಗರ",
      "d_name_en": "Bengaluru Urban",
      "whasAppLink": "https://chat.whatsapp.com/DVKBAzamrVM9B6aDuWXtHw"
  },
  {
      "d_id": 4,
      "d_name_ka": "ಬೆಳಗಾವಿ",
      "d_name_en": "Belagavi",
      "whasAppLink": "https://chat.whatsapp.com/Lvd5EmKhdWmHI9jls5xhkd"
  },
  {
      "d_id": 5,
      "d_name_ka": "ಬಳ್ಳಾರಿ",
      "d_name_en": "Ballari",
      "whasAppLink": "https://chat.whatsapp.com/Le6YAuKBMXGBYefYx5dLPI"
  },
  {
      "d_id": 6,
      "d_name_ka": "ಬೀದರ್",
      "d_name_en": "Bidar",
      "whasAppLink": "https://chat.whatsapp.com/LQtin9voNYt9NuFPAV4XC7"
  },
  {
      "d_id": 7,
      "d_name_ka": "ಚಾಮರಾಜನಗರ",
      "d_name_en": "Chamarajanagara",
      "whasAppLink": "https://chat.whatsapp.com/KawqZP5UXFXJ8aqIOtFjae"
  },
  {
      "d_id": 8,
      "d_name_ka": "ಚಿಕ್ಕಬಳ್ಳಾಪುರ",
      "d_name_en": "Chikkaballapura",
      "whasAppLink": "https://chat.whatsapp.com/C2Jtlbbv6jwHTeeCW7ik2l"
  },
  {
      "d_id": 9,
      "d_name_ka": "ಚಿಕ್ಕಮಗಳೂರು",
      "d_name_en": "Chikkamagaluru",
      "whasAppLink": "https://chat.whatsapp.com/E61mgP8gbl3HQffeq3ZZU9"
  },
  {
      "d_id": 10,
      "d_name_ka": "ಚಿತ್ರದುರ್ಗ",
      "d_name_en": "Chitradurga",
      "whasAppLink": "https://chat.whatsapp.com/LtCz2SvleQHDuTcurEiv2X"
  },
  {
      "d_id": 11,
      "d_name_ka": "ದಕ್ಷಿಣಕನ್ನಡ",
      "d_name_en": "Dakshina Kannada",
      "whasAppLink": "https://chat.whatsapp.com/FbU2NFqDXlkKCK5TuTnTPy"
  },
  {
      "d_id": 12,
      "d_name_ka": "ದಾವಣಗೆರೆ",
      "d_name_en": "Davanagere",
      "whasAppLink": "https://chat.whatsapp.com/CRUIVh4norH9mvmc701uTo"
  },
  {
      "d_id": 13,
      "d_name_ka": "ಧಾರವಾಡ",
      "d_name_en": "Dharwad",
      "whasAppLink": "https://chat.whatsapp.com/Iix4vXkuxPPKe0KKblvM1j"
  },
  {
      "d_id": 14,
      "d_name_ka": "ಗದಗ",
      "d_name_en": "Gadag",
      "whasAppLink": "https://chat.whatsapp.com/GVw2Nkett4P9hsg95SxUDF"
  },
  {
      "d_id": 15,
      "d_name_ka": "ಕಲ್ಬುರ್ಗಿ",
      "d_name_en": "Kalburgi",
      "whasAppLink": "https://chat.whatsapp.com/Hav037fdWqy8VS3B6ThSlC"
  },
  {
      "d_id": 16,
      "d_name_ka": "ಹಾಸನ",
      "d_name_en": "Hasan",
      "whasAppLink": "https://chat.whatsapp.com/IdWCceEAgpt2fzApRjkJbe"
  },
  {
      "d_id": 17,
      "d_name_ka": "ಹಾವೇರಿ",
      "d_name_en": "Haveri",
      "whasAppLink": "https://chat.whatsapp.com/DVbmbje3uPe9JRP9K0ES9h"
  },
  {
      "d_id": 18,
      "d_name_ka": "ಕೊಡಗು",
      "d_name_en": "Kodagu",
      "whasAppLink": "https://chat.whatsapp.com/BGufOXvGZs6KQE14zUJ3ct"
  },
  {
      "d_id": 19,
      "d_name_ka": "ಕೋಲಾರ",
      "d_name_en": "Kolar",
      "whasAppLink": "https://chat.whatsapp.com/EvKg2XrhV33JAzLMsguqsU"
  },
  {
      "d_id": 20,
      "d_name_ka": "ಕೊಪ್ಪಳ",
      "d_name_en": "Koppala",
      "whasAppLink": "https://chat.whatsapp.com/EzwItiTsVXVLT8JaH3HrFZ"
  },
  {
      "d_id": 21,
      "d_name_ka": "ಮಂಡ್ಯ",
      "d_name_en": "Mandya",
      "whasAppLink": "https://chat.whatsapp.com/CMsHBfJH2S25gOCj5gLIKx"
  },
  {
      "d_id": 22,
      "d_name_ka": "ಮೈಸೂರು",
      "d_name_en": "Mysuru",
      "whasAppLink": "https://chat.whatsapp.com/F412wilykW17fDIFMXfQm5"
  },
  {
      "d_id": 23,
      "d_name_ka": "ರಾಯಚೂರು",
      "d_name_en": "Rayachuru",
      "whasAppLink": "https://chat.whatsapp.com/GFpSmITW6qpA13AWaabnjY"
  },
  {
      "d_id": 24,
      "d_name_ka": "ರಾಮನಗರ",
      "d_name_en": "Ramanagara",
      "whasAppLink": "https://chat.whatsapp.com/DOVV0VeIG5SFTG5vDSLEXf"
  },
  {
      "d_id": 25,
      "d_name_ka": "ಶಿವಮೊಗ್ಗ",
      "d_name_en": "Shivamogga",
      "whasAppLink": "https://chat.whatsapp.com/FcI0aG0fxnZEPGCfdoZyZA"
  },
  {
      "d_id": 26,
      "d_name_ka": "ತುಮಕೂರು",
      "d_name_en": "Tumakuru",
      "whasAppLink": "https://chat.whatsapp.com/ENcwhvvLs9ICsicyGG2U8O"
  },
  {
      "d_id": 27,
      "d_name_ka": "ಉಡುಪಿ",
      "d_name_en": "Udupi",
      "whasAppLink": "https://chat.whatsapp.com/CaTDUsVeiZM13S6Zj8WWxi"
  },
  {
      "d_id": 28,
      "d_name_ka": "ಉತ್ತರಕನ್ನಡ",
      "d_name_en": "Uttara Kannada",
      "whasAppLink": "https://chat.whatsapp.com/HnhMt3B59ApEwiumqd0USc"
  },
  {
      "d_id": 29,
      "d_name_ka": "ವಿಜಯನಗರ",
      "d_name_en": "Vijaya Nagara",
      "whasAppLink": "https://chat.whatsapp.com/GlBtIS5DeqF6T0bmhwpID2"
  },
  {
      "d_id": 30,
      "d_name_ka": "ವಿಜಯಪುರ",
      "d_name_en": "Vijayapura",
      "whasAppLink": "https://chat.whatsapp.com/CkTw8jcI09Z3YazQaeaY5r"
  },
  {
      "d_id": 31,
      "d_name_ka": "ಯಾದಗಿರಿ",
      "d_name_en": "Yadgir",
      "whasAppLink": "https://chat.whatsapp.com/DqdoiUTnSRZAT8QuMIKDVC"
  }
]

const Demo = () => {
    const defaultOptions = {
        loop: true,
        autoplay: true, 
        animationData: Verify,
        
      };
      const [data, setdata] = useState();
      const getWhatsAppLink = (districtId) => {
        const district = districtWhatsApp.find((district) => district.d_id === districtId);
        return district ? district.whasAppLink : null;
    };
      useEffect(() => {
        // Get the URLSearchParams object from the current URL
        const urlSearchParams = new URLSearchParams(window.location.search);
    
        // Get the value of the 'data' parameter
        const dataValue = urlSearchParams.get('data');
    
        // Log or use the data value as needed
        console.log('Data Value:', dataValue);
        setdata(JSON.parse(dataValue));
    
        // You can set it to the state or perform any other actions with the data
      }, []);
  return (
    <div class="container">
          <Lottie options={defaultOptions}
              height={300}
              width={300}
              />
      {/* <br /> */}
      <table>
            <tr>
              <th>ರೆಫರೆನ್ಸ್ ಸಂಖ್ಯೆ</th>
              <th>ದಿನಾಂಕ</th>
              <th>ಮೊತ್ತ</th>
            </tr>
            <tr>
              <td>{data?.bank_ref}</td>
              <td>{data?.join_date}</td>
              <td>
                {" "}
                <i class="fa fa-inr"></i> {data?.amount}
              </td>
            </tr>
          </table>
      <div>
        {" "}
        <center>
          {" "}
          ಕರ್ನಾಟಕದಲ್ಲಿ ಪ್ರಾದೇಶಿಕ, ಪ್ರಾಮಾಣಿಕ, ಜನಪರ ರಾಜಕಾರಣದ ಮೂಲಕ ಜನಸ್ನೇಹಿ
          ವ್ಯವಸ್ಥೆ ನಿರ್ಮಾಣ ಮಾಡಲು <br /> ಕೆ.ಆರ್.ಎಸ್ ಪಕ್ಷದ ಜೊತೆ ಕೈ
          ಜೋಡಿಸಿರುವುದಕ್ಕಾಗಿ ನಿಮಗೆ ಧನ್ಯವಾದಗಳು. <b> </b>
          <br />
          <br />
          <a class="button-4" href={getWhatsAppLink(Number.parseInt(data?.districtId))}>
            {" "}
            ನಿಮ್ಮ Your-District ಜಿಲ್ಲೆಯ KRS ಪಕ್ಷದ WhatsApp ಗ್ರೂಪ್ ಸೇರಲು ಇಲ್ಲಿ
            ಕ್ಲಿಕ್ ಮಾಡಿ{" "}
          </a>
          <br/>
          {/* <a
            class="button-4"
            href="https://wa.me/+91your-mobile-number?text=https://your-whatsapp-link"
          >
            ಸೇರ್ಪಡೆಗೊಂಡ ನೂತನ ಸದಸ್ಯರಿಗೆ WhatsApp ಗ್ರೂಪ್ ಲಿಂಕ್ ಕಳುಹಿಸಲು ಇಲ್ಲಿ
            ಕ್ಲಿಕ್ ಮಾಡಿ
          </a> */}
          <br />
          {/* <br />
          <br /> */}
          <div>
          ಹೆಸರು : {data?.name}
          <br />
          ನಿಮ್ಮ ಸದಸ್ಯತ್ವ ಸಂಖ್ಯೆ : {data?.id}
          </div>
        </center>
        <br />
        <center>
          ಪಾವತಿ ವಿವರಗಳು
          <br />
        

          <br />
          {/* <a class="button-4" href="Your-Main-Home-URL">
            <b>ಮುಖ ಪುಟ</b>
          </a> */}
        </center>
      </div>
    </div>
  );
};

export default Demo;
